<template>
  <div>
    <QuotePaymentHeader v-if="!successData" paymentType="fci" />

    <v-form v-if="!successData" ref="form" lazy-validation>
      <v-row>
        <v-col>
          <v-text-field
            v-model="name"
            :rules="[rules.required]"
            :label="$t('forms.completeName')"
            hide-details="auto"
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            v-model="document"
            v-mask="
              document.length <= 14 ? mask.cpfCnpj.cpf : mask.cpfCnpj.cnpj
            "
            :rules="[rules.documentCheck]"
            :label="$t('forms.document')"
            hide-details="auto"
            outlined
          />
        </v-col>
      </v-row>

      <QuotePaymentActions @submit="validate" />
    </v-form>

    <QuotePaymentFciSuccess v-else :successData="successData" />
  </div>
</template>

<script>
import QuotePaymentHeader from './QuotePaymentHeader'
import QuotePaymentActions from './QuotePaymentActions'
import QuotePaymentFciSuccess from './QuotePaymentFciSuccess'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { cpfCnpj, phone } from '@/util/masks'
import { email, required, documentCheck } from '@/util/errorHandling'

export default {
  name: 'QuotePaymentFci',

  components: {
    QuotePaymentHeader,
    QuotePaymentActions,
    QuotePaymentFciSuccess,
  },

  data() {
    return {
      name: '',
      email: '',
      document: '',

      rules: {
        email,
        required,
        documentCheck,

        min: (val) => (!!val && val.length >= 7) || this.$t('rules.required'),
        name: (val) => (!!val && val.length >= 6) || this.$t('rules.required'),
        number: (val) =>
          (!!val && val.length >= 19) || this.$t('rules.required'),
        expiry: (val) =>
          (!!val && val.length >= 7) || this.$t('rules.required'),
        ccv: (val) => (!!val && val.length >= 2) || this.$t('rules.required'),
      },

      mask: { cpfCnpj, phone },
    }
  },

  computed: {
    ...mapGetters(['quotes', 'successData']),
  },

  methods: {
    ...mapActions(['doQuotePayment', 'fetchQuoteItems']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.$refs.form.validate()) {
        const document = this.document.replace(/[^0-9]+/g, '')

        const paymentData = {
          payer_name: this.name,
          payer_document: document,
          quote_id: this.quotes.id,
          installment_amount: 1,
          method: 'VALUELESS',
        }

        this.doQuotePayment(paymentData)
      }
    },
  },
}
</script>
